var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { WarningIcon } from '@phosphor-icons/react';
import { Alert, Button, Container, Group, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router";
export default function CloseAccount() {
    var _this = this;
    var _a = useDisclosure(false), opened = _a[0], _b = _a[1], open = _b.open, close = _b.close;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var navigate = useNavigate();
    var doCloseAccount = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch('/api/account/close', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        navigate('/login');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return _jsxs(Container, { children: [_jsx(Alert, { variant: "light", color: "red", title: "Warning", icon: _jsx(WarningIcon, {}), mt: "md", children: "Closing all your account will delete all your data, and cannot be undone." }), _jsx(Button, { mt: "md", variant: "filled", color: "red", onClick: open, children: "Close Account" }), _jsxs(Modal, { opened: opened, onClose: close, title: "Confirm Account Closure", centered: true, size: "sm", styles: {
                    title: { fontWeight: 700 }
                }, children: [_jsx(Text, { size: "sm", c: "dimmed", children: "Are you sure you want to close your account?" }), _jsxs(Group, { justify: "flex-end", mt: "xl", gap: "sm", children: [_jsx(Button, { variant: "filled", color: "red", onClick: doCloseAccount, children: "Confirm" }), _jsx(Button, { variant: "default", onClick: close, children: "Cancel" })] })] })] });
}
